/**
 * Whole percentages that add up to 100 (largest remainder), so the legend never
 * shows 99% or 101% because of rounding.
 */
export const toPercentages = (counts: number[]): number[] => {
    const total = counts.reduce((sum, count) => sum + count, 0);
    if (total <= 0) {
        return counts.map(() => 0);
    }
    const exact = counts.map((count) => (count / total) * 100);
    const rounded = exact.map(Math.floor);
    let missing = 100 - rounded.reduce((sum, value) => sum + value, 0);
    const byRemainder = exact
        .map((value, index) => ({ index, remainder: value - Math.floor(value) }))
        .sort((a, b) => b.remainder - a.remainder);
    for (const { index } of byRemainder) {
        if (missing <= 0) break;
        rounded[index] += 1;
        missing -= 1;
    }
    return rounded;
};
